"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModalEventRepublisher = void 0;
/*---------------------------------------------------------------------------------------------
*  Licensed to the .NET Foundation under one or more agreements.
*  The .NET Foundation licenses this file to you under the MIT license.
*--------------------------------------------------------------------------------------------*/
const EventStreamEvents_1 = require("../EventStream/EventStreamEvents");
class ModalEventRepublisher {
    constructor(eventStreamReference) {
        this.eventStreamReference = eventStreamReference;
    }
    getSpecificEvent(event) {
        const mode = event.mode;
        if (event instanceof EventStreamEvents_1.DotnetAcquisitionStarted) {
            switch (mode) {
                case 'sdk':
                    return event.installType === 'global' ? new EventStreamEvents_1.DotnetGlobalSDKAcquisitionStarted(event.requestingExtensionId) : null;
                case 'runtime':
                    return new EventStreamEvents_1.DotnetRuntimeAcquisitionStarted(event.requestingExtensionId);
                case 'aspnetcore':
                    return new EventStreamEvents_1.DotnetASPNetRuntimeAcquisitionStarted(event.requestingExtensionId);
                default:
                    break;
            }
        }
        else if (event instanceof EventStreamEvents_1.DotnetAcquisitionTotalSuccessEvent) {
            switch (mode) {
                case 'sdk':
                    return event.installType === 'global' ? new EventStreamEvents_1.DotnetGlobalSDKAcquisitionTotalSuccessEvent(event.install) : null;
                case 'runtime':
                    return new EventStreamEvents_1.DotnetRuntimeAcquisitionTotalSuccessEvent(event.install);
                case 'aspnetcore':
                    return new EventStreamEvents_1.DotnetASPNetRuntimeAcquisitionTotalSuccessEvent(event.install);
                default:
                    break;
            }
        }
        else if (event instanceof EventStreamEvents_1.DotnetAcquisitionFinalError) {
            switch (mode) {
                case 'sdk':
                    return event.installType === 'global' ? new EventStreamEvents_1.DotnetGlobalSDKAcquisitionError(event.error, event.originalEventName, event.install) : null;
                case 'runtime':
                    return new EventStreamEvents_1.DotnetRuntimeFinalAcquisitionError(event.error, event.originalEventName, event.install);
                case 'aspnetcore':
                    return new EventStreamEvents_1.DotnetASPNetRuntimeFinalAcquisitionError(event.error, event.originalEventName, event.install);
                default:
                    break;
            }
        }
        else if (event instanceof EventStreamEvents_1.DotnetAcquisitionRequested) {
            switch (mode) {
                case 'sdk':
                    return event.installType === 'global' ? new EventStreamEvents_1.DotnetGlobalSDKAcquisitionRequested(event.startingVersion, event.requestingId, event.mode) : null;
                case 'runtime':
                    return new EventStreamEvents_1.DotnetRuntimeAcquisitionRequested(event.startingVersion, event.requestingId, event.mode);
                case 'aspnetcore':
                    return new EventStreamEvents_1.DotnetASPNetRuntimeAcquisitionRequested(event.startingVersion, event.requestingId, event.mode);
                default:
                    break;
            }
        }
        return null;
    }
    republishEvent(event) {
        const modeSpecificEvent = this.getSpecificEvent(event);
        if (modeSpecificEvent) {
            this.eventStreamReference.post(modeSpecificEvent);
        }
    }
    post(event) {
        if (event instanceof EventStreamEvents_1.GenericModalEvent) {
            this.republishEvent(event);
        }
    }
    dispose() {
    }
}
exports.ModalEventRepublisher = ModalEventRepublisher;
//# sourceMappingURL=ModalEventPublisher.js.map